/**
 * Stories Block.
 * 
 */

/**
 * Mobile: Sync'd slick sliders. Stories: 1 slide. Photos: centered 3 slides.
 * Desktop: 1-slide (page) slick slider.
 */

// Set up slick slider for story slides.
let 
	$window = $(window),
	sliderBreakpoint = 768,
	$myPhotoSlider = $('.stories-block__photos'),
	$myStorySlider = $('.stories-block__stories'),
    myPhotoSliderSettings = {
        adaptiveHeight: false,
		arrows: false,
		asNavFor: $myStorySlider,
    	centerMode: true,
		dots: false,
		fade: false,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
		variableWidth: true,
        responsive: [
			{
				// breakpoint: 1023,
				// settings: 'unslick'
			}
        ]
    },
	myStorySliderSettings = {
        adaptiveHeight: false,
		arrows: false,
		// asNavFor: $myPhotoSlider,
		dots: false,
		fade: true,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
		swipe: false,
        swipeToSlide: false,
        responsive: [
			{
				// breakpoint: 1023,
				// settings: 'unslick'
			}
        ]
    };

function initSlider() {
	// console.log('STORIES: initSlider():'+$window.width());
	$myPhotoSlider.on('afterChange', function(event, slick, currentSlide, nextSlide) {
		// console.log('$myPhotoSlider afterChange!'+currentSlide);
		$(".slick-slide .stories-block__photo").removeClass('active');
		$('.slick-center .stories-block__photo').addClass('active');        
	});
	  
	$myStorySlider.slick(myStorySliderSettings);

	if ($window.width() >= sliderBreakpoint) {
		initDesktopSlider();
	} else {
		$myPhotoSlider.slick(myPhotoSliderSettings);
	}
}

function initDesktopSlider() {
	// console.log('STORIES: initDesktopSlider()');
	let 
		$allPhotos = $('.stories-block__photo');

	$allPhotos.on('click', function() {
		// console.log('CLICK: '+$(this).data('index'));
		if (!$(this).hasClass('active')) {
			$myStorySlider.slick('slickGoTo', parseInt($(this).data('index')) - 1);
			$allPhotos.removeClass('active');
			$(this).addClass('active');
		}
	});
}
function killDesktopSlider() {
	// console.log('STORIES: killDesktopSlider()');
	let 
		$allPhotos = $('.stories-block__photo');

	$allPhotos.off('click');
}

let
	prevWindowW = $window.width(),
	currWindowW = prevWindowW;

function initResizeWatcher() {
	// console.log('STORIES: initResizeWatcher()');
	$window.on('resize', function() {
		currWindowW = $window.width();
		// console.log('STORIES: WINDOW RESIZED: '+currWindowW+': '+prevWindowW);
		// Viewport width crosses from mobile to desktop.
		if ((currWindowW >= sliderBreakpoint) && (prevWindowW < sliderBreakpoint)) {
			// Unslick mobile photo slider.
			// Init desktop photo clicks.
			if ($myPhotoSlider.hasClass('slick-initialized')) {
				$myPhotoSlider.slick('unslick');
			}
			initDesktopSlider();
		}
		// Viewport width crosses from desktop to mobile.
		if ((currWindowW < sliderBreakpoint) && (prevWindowW >= sliderBreakpoint)) {
			// Slick mobile photo slider.
			// Kill desktop photo clicks.
			// Slick select active photo.
			if (!$myPhotoSlider.hasClass('slick-initialized')) {
				let $activePhoto = $('.stories-block__photo.active');
				$myPhotoSlider.slick(myPhotoSliderSettings);
				$myPhotoSlider.slick('slickGoTo', parseInt($activePhoto.data('index')) - 1);
			}
			killDesktopSlider();
		}
		prevWindowW = $window.width();
	});
}

exports.init = function () {
	// console.log('STORIES: exports.init');
	// Run init methods...

	if(window.matchMedia("(pointer: coarse)").matches) {
		// touchscreen
	} else {
		sliderBreakpoint = sliderBreakpoint - 15;
	}

	initSlider();
	initResizeWatcher();
};